import { render, staticRenderFns } from "./ReserveStage2.vue?vue&type=template&id=7121380d&scoped=true&"
import script from "./ReserveStage2.vue?vue&type=script&lang=js&"
export * from "./ReserveStage2.vue?vue&type=script&lang=js&"
import style0 from "./ReserveStage2.vue?vue&type=style&index=0&id=7121380d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7121380d",
  null
  
)

export default component.exports